import {
  LOGIN_END_SUCCESS,
  LOGIN_END_FAILED,
  LOGIN_START,
  RESET_AUTH_ERROR,
  RESET_PASSWORD,
  RESET_PASSWORD_FAILED
} from "../constants";

const initialState = {
  isLoggingIn: false,
  error: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_START:
      return {
        ...state,
        isLoggingIn: true
      };
    case LOGIN_END_SUCCESS:
      return {
        ...state,
        isLoggingIn: false
      };
    case LOGIN_END_FAILED:
      return {
        ...state,
        isLoggingIn: false,
        error: action.payload
      };
    case RESET_AUTH_ERROR:
      return {
        ...state,
        error: {}
      };
    case RESET_PASSWORD: {
      return {
        ...state,
        error: {}
      };
    }
    case RESET_PASSWORD_FAILED: {
      return {
        ...state,
        error: action.payload
      };
    }
    default:
      return state;
  }
};
